import React from "react";
import Image from "bodycodi/cmap/app/components/common/image";
import { isEmpty } from "bodycodi/cmap/app/js/common";
import empty from "bodycodi/cmap/app/img/center-none.png";

type CenterListProp = {
  PartnerVO: any;
  MemberDtlVO: any;
};

const CenterList = ({ PartnerVO, MemberDtlVO }: CenterListProp) => {
  const dt = !MemberDtlVO.regDt ? "" : MemberDtlVO.regDt.split(" ")[0].split("-");
  const src = !isEmpty(PartnerVO.partnerImageFile) ? PartnerVO.partnerImageFile : empty;

  return (
    <div className="member-wrap">
      <div className="member-title">소속 센터</div>
      <div className="member-center-list">
        <Image className="member-center-list-profile" src={src} />
        <div className="member-center-list-text">
          <div className="black">
            {PartnerVO.partnerName} {PartnerVO.companyName}
          </div>
          <div className="gray">
            등록일: {dt[0]}년 {dt[1]}월 {dt[2]}일
          </div>
        </div>
      </div>
    </div>
  );
};

export default CenterList;
